import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TabContent, TabPane, NavItem, NavLink, Nav } from 'reactstrap';


class TabGroup extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTab: this.props.activeTab
    };
  }

  componentDidUpdate(previousProps) {
    if (this.props.activeTab !== previousProps.activeTab) {
      this.setState({
        activeTab: this.props.activeTab
      });
    }
  }

  toggleActiveTab(index) {
    this.setState({
      activeTab: index,
    });
    this.props.onTabChanged && this.props.onTabChanged(index);
  }

  render() {
    return (<>
      <Nav tabs>
        {
          this.props.tabs.map((tab, index) => {
            return (
              <NavItem key={index}>
                <NavLink active={this.state.activeTab === index} onClick={this.toggleActiveTab.bind(this, index)}>{tab.label}</NavLink>
              </NavItem>
            )
          })
        }
      </Nav>
      <TabContent activeTab={this.state.activeTab}>
        {
          this.props.tabs.map((tab, index) => {
            return (
              < TabPane key={index} tabId={index} >
                {tab.render()}
              </TabPane >
            )
          })
        }
      </TabContent>
    </>);
  }
}

const TabType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired
});

export const TabsType = PropTypes.arrayOf(TabType);

TabGroup.propTypes = {
  tabs: PropTypes.arrayOf(TabType).isRequired,
  activeTab: PropTypes.number,
  onTabChanged: PropTypes.func
}

TabGroup.defaultProps = {
  activeTab: 0
}

export default TabGroup;
